module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x_panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "x_content"
  }, [_c('ChemicalChecklist')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_vm._v("Manage Chemical Checklist")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73ff3bfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ChemicalChecklist/ChecklistManager.vue
// module id = 827
// module chunks = 1